import React from 'react'
import NavItem from '../../Layout/NavItem'
import { NavItemProps } from '../../Layout/NavItem'

const ReferentNavItem: React.FC<NavItemProps> = (props) =>
  <NavItem {...props} base='referent' />

export default ReferentNavItem